import { render, staticRenderFns } from "./TpmsListItem.vue?vue&type=template&id=435dcd84"
import script from "./TpmsListItem.vue?vue&type=script&lang=js"
export * from "./TpmsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports